<template>
  <v-layout wrap>
    <v-navigation-drawer
      v-model="openDrawer"
      fixed
      right
      temporary
      :width="openDrawer ? 400 : 0"
      class="filter-nav-drawer primary"
      enable-resize-watcher
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
    <v-btn 
      v-show="closeBtn" 
      fab 
      small 
      absolute 
      color="orange"
      class="closeBtn" 
      @click="openDrawer = !openDrawer">
        <v-icon>close</v-icon>
      </v-btn>
    <div class="pa-3">
      <slot></slot>
    </div>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    closeBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions('theme', [
      'setValue',
      'hideDrawer',
      'restoreDefault'
    ]),
    widgetColorChange(event) {
      // console.log(event.target.value);
      this.setWidgetColor(event.target.value)
    },
    cardColorChange(event) {
      this.setCardColor(event.target.value)
    },
    setCardColor(color) {
      let payload = {
        module: 'plantOverview',
        subModule: 'card',
        value: color
      }
      this.setValue(payload)
    },
    setWidgetColor(color) {
      let payload = {
        module: 'plantOverview',
        subModule: 'widget',
        value: color
      }
      this.setValue(payload)
    },
    background(color) {
      return {
        'background-color': color
      }
    }
  },
  computed: {
    ...mapGetters('theme', ['getValue']),
    cardColor() {
      let payload = {
        module: 'plantOverview',
        subModule: 'card'
      }

      return this.getValue(payload)
    },
    widgetColor() {
      let payload = {
        module: 'plantOverview',
        subModule: 'widget'
      }

      return this.getValue(payload)
    },
    openDrawer: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('change:state', value)
      }
    }
  }
}
</script>

<style>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.w-10 {
  width: 2.5rem !important;
}
.m-2 {
  margin: 0.5rem !important;
}
.h-10 {
  height: 2.5rem !important;
}
.float-left {
  float: left !important;
}

.cursor-pointer {
  cursor: pointer !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.shadow-outline {
  -webkit-box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5) !important;
  box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5) !important;
}

/* Button */
.vs-button.includeIcon {
  float: none;
}
.vs-button-primary.vs-button-filled {
  background: red !important;
}

.customizer-btn {
  position: fixed;
  top: 50%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
}
.vs-button {
  font-size: 1rem;
}
.includeIconOnly {
  width: 38px !important;
  height: 38px !important;
}
.includeIcon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  float: left;
}
.vs-button {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  padding: 10px;
  border: 0;
  border-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: transparent;
}

.closeBtn {
  right: 0px;
  margin: 15px;
  position: absolute !important;
}

.filter-nav-drawer{
  height: 100vh; 
  z-index: 11 !important;
}
</style>
